import DetailsUse from "components/Atoms/SharedComponents/CRUD/details-use";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getProductDetailsRequest } from "services/modules/products";
import { detailsData } from "templates/products/productsListing/details";

export default function Details({ details }) {
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  // let [searchParams] = useSearchParams();
  // const id = searchParams.get("id");

  // const getDetails = async () => {
  //   dispatch(getProductDetailsRequest({ id }));
  // };
  // useEffect(() => {
  //   if (id) getDetails();
  // }, [id]);
  return (
    <DetailsUse
      data={{
        deleteBtn: false,
        editBtn: false,
        data: {
          list: detailsData({ data: details, t }),
          checkBox: [
            {
              label: t("products.label_is_wrappable"),
              checked: details?.is_wrappable,
            },
            { label: t("products.label_active"), checked: details?.is_visible },
          ],
        },
      }}
    />
  );
}
